<template>
    <div>
        <!--<registration-bonus-banner v-if="registrationBanner"
        :currency="currency" />-->

        <p class="title title-step">{{ 'components.pages.registration.step1' | translate }}</p>
        <p class="subtitle">
            {{ 'components.pages.login.login password.title' | translate }}

            <router-link :to="{ name: 'login' }" class="login-link">{{ 'components.pages.login.login' | translate }}</router-link>
        </p>
        <!-- Display of registration errors -->
        <div class="message is-danger" v-if="error">
            <div class="message-header">
                <p>{{ 'components.pages.registration.error title' | translate }}</p>
                <button class="delete" aria-label="delete" @click="error = null"></button>
            </div>
            <div class="message-body">{{ error }}</div>
        </div>
        <form @submit.prevent="submit()" :class="{ 'is-loading': loading }" role="form">
            <!-- Messenger type and number input: desktop/mobile-->
            <div class="field field-block has-addons field-block-phone">
                <div class="field-block-wrapper">
                    <div class="control has-icons-left is-expanded">
                        <masked-phone
                            v-if="client && client.login.phoneMask"
                            v-model="phone"
                            :mask="client.login.phoneMask"
                            v-validate="{
                                required: true,
                                length: (client.login.phoneMask.match(/\d/g) || []).length,
                                'unique-login': true
                            }"
                            data-vv-name="phone number"
                            data-vv-validate-on="input"
                            data-vv-delay="300"
                            class="input is-large"
                            autofocus="on"
                        />
                        <input
                            v-else
                            v-model.trim="phone"
                            v-validate="'required|min:9|max:50|unique-login'"
                            data-vv-name="phone number"
                            data-vv-validate-on="input"
                            data-vv-delay="300"
                            :placeholder="'components.pages.registration.phone number' | translate"
                            class="input is-large"
                            type="text"
                            autofocus="on"
                            maxlength="50"
                        />
                        <span class="icon is-small is-left"><i class="fas fa-phone"></i></span>
                    </div>
                    <p class="help is-danger" v-if="errors.has('phone number:required')">
                        {{ 'components.pages.registration.validation.phone number required' | translate }}
                    </p>
                    <p class="help is-danger" v-if="errors.has('phone number:min')">
                        {{
                            $t(
                                'components.pages.registration.validation.phone number min length',
                                $validator.fields.find({ name: 'phone number' }).rules
                            )
                        }}
                    </p>
                    <p class="help is-danger" v-if="errors.has('phone number:max')">
                        {{
                            $t(
                                'components.pages.registration.validation.phone number max length',
                                $validator.fields.find({ name: 'phone number' }).rules
                            )
                        }}
                    </p>
                    <p class="help is-danger" v-if="errors.has('phone number:unique-login')">
                        {{ 'components.pages.registration.validation.phone number in use' | translate }}
                    </p>
                </div>
                <p class="control fied-select-tablet">
                    <span class="select is-large">
                        <select v-model="messenger" tabindex="-1">
                            <option v-for="m in availableMessengers" :key="m" :value="m">{{ messengerNames[m] }}</option>
                        </select>
                    </span>
                </p>
            </div>
            <!-- Messenger type selection: mobile-->
            <div class="field field-select-mobile">
                <div class="buttons is-centered has-addons">
                    <span
                        v-for="m in availableMessengers"
                        :key="m"
                        class="button"
                        :class="{ 'is-warning': messenger == m }"
                        @click="messenger = m"
                        >{{ messengerNames[m] }}</span
                    >
                </div>
            </div>

            <template v-if="isLiveBetLine">
                <div class="field">
                    <div class="control has-icons-left has-icons-right">
                        <input
                            v-model.trim="firstName"
                            v-validate="{ required: true }"
                            data-vv-name="firstName"
                            data-vv-validate-on="input"
                            :placeholder="'components.pages.profile.settings.first name' | translate"
                            class="input is-large"
                            type="text"
                            maxlength="50"
                        />
                        <span class="icon is-small is-left"><i class="fas fa-user"></i></span>
                    </div>
                    <p v-if="errors.has('firstName:required')" class="help is-danger">
                        {{ 'components.pages.profile.validation.field required' | translate }}
                    </p>
                </div>
                <div class="field">
                    <div class="control has-icons-left has-icons-right">
                        <input
                            v-model.trim="lastName"
                            v-validate="{ required: true }"
                            data-vv-name="lastName"
                            data-vv-validate-on="input"
                            :placeholder="'components.pages.profile.settings.last name' | translate"
                            class="input is-large"
                            type="text"
                            maxlength="50"
                        />
                        <span class="icon is-small is-left"><i class="fas fa-user"></i></span>
                    </div>
                    <p v-if="errors.has('lastName:required')" class="help is-danger">
                        {{ 'components.pages.profile.validation.field required' | translate }}
                    </p>
                </div>
                <div class="field">
                    <div class="control has-icons-left has-icons-right">
                        <input
                            v-validate="{ required: true }"
                            data-vv-name="dateOfBirth"
                            data-vv-validate-on="input"
                            ref="dateOfBirth"
                            class="input is-large"
                            type="text"
                            readonly
                            :placeholder="'components.pages.profile.settings.date of birth' | translate"
                        />
                        <span class="icon is-small is-left"><i class="fas fa-calendar"></i></span>
                    </div>
                    <p v-if="errors.has('dateOfBirth:required')" class="help is-danger">
                        {{ 'components.pages.profile.validation.field required' | translate }}
                    </p>
                </div>
            </template>

            <!-- Password input-->
            <div class="field">
                <div class="control has-icons-left has-icons-right">
                    <input
                        v-model.trim="password"
                        v-validate="{ required: true, min: 4, max: 20, regex: /^[^\s]+$/ }"
                        data-vv-name="password"
                        data-vv-validate-on="input"
                        :placeholder="'components.pages.registration.password' | translate"
                        class="input is-large"
                        :type="showPassword ? 'text' : 'password'"
                        maxlength="20"
                        ref="password"
                    />
                    <span class="icon is-small is-left"><i class="fas fa-lock"></i></span>
                    <a class="icon is-small is-right bng-clickable" @click="toggleShowPassword('password')">
                        <span v-show="!showPassword"><i class="far fa-eye-slash"></i></span>
                        <span v-show="showPassword"><i class="far fa-eye"></i></span>
                    </a>
                </div>
                <p class="help is-danger" v-if="errors.has('password:required')">
                    {{ 'components.pages.registration.validation.password required' | translate }}
                </p>
                <p class="help is-danger" v-if="errors.has('password:min')">
                    {{ 'components.pages.registration.validation.password min length' | translate }}
                </p>
                <p class="help is-danger" v-if="errors.has('password:max')">
                    {{ 'components.pages.registration.validation.password max length' | translate }}
                </p>
            </div>
            <div class="field">
                <div class="control has-icons-left has-icons-right">
                    <input
                        v-model.trim="confirmedPassword"
                        v-validate="{ required: true, is: password }"
                        data-vv-name="confirmedPassword"
                        data-vv-validate-on="input"
                        :placeholder="'components.pages.registration.repeat password' | translate"
                        class="input is-large"
                        :type="showPassword ? 'text' : 'password'"
                        ref="confirmedPassword"
                    />
                    <span class="icon is-small is-left"><i class="fas fa-lock"></i></span>
                    <a class="icon is-small is-right bng-clickable" @click="toggleShowPassword('password')">
                        <span v-show="!showPassword"><i class="far fa-eye-slash"></i></span>
                        <span v-show="showPassword"><i class="far fa-eye"></i></span>
                    </a>
                </div>
                <p class="help is-danger" v-if="errors.has('confirmedPassword:required')">
                    {{ 'components.pages.registration.validation.password required' | translate }}
                </p>
                <p class="help is-danger" v-if="errors.has('confirmedPassword:is')">
                    {{ 'components.pages.login.validation.confirmed' | translate }}
                </p>
            </div>
            <!-- Alias input-->
            <div v-if="askAliasDuringRegistration" class="field">
                <div class="control has-icons-left">
                    <input
                        v-model.trim="alias"
                        v-validate="'min:3|max:50'"
                        data-vv-name="alias"
                        data-vv-validate-on="input"
                        :placeholder="'components.pages.registration.alias' | translate"
                        class="input is-large"
                        type="text"
                        maxlength="30"
                    />
                    <span class="icon is-small is-left"><i class="fas fa-user"></i></span>
                </div>
                <p class="help is-danger" v-if="errors.has('alias:min')">
                    {{ 'components.pages.registration.validation.alias min length' | translate }}
                </p>
                <p class="help is-danger" v-if="errors.has('alias:max')">
                    {{ 'components.pages.registration.validation.alias max length' | translate }}
                </p>
            </div>
            <!-- Recaptcha-->
            <recaptcha
                v-show="false"
                ref="recaptcha"
                :on-response="
                    response => {
                        recaptchaResponse = response;
                    }
                "
            />
            <!-- Currency input-->
            <div v-if="visibleCurrencies && visibleCurrencies.length > 1" class="field bng-center-field">
                <div class="control has-icons-left">
                    <div class="select is-large">
                        <select v-model="currency" v-validate="'required'" data-vv-name="currency" data-vv-validate-on="change">
                            <option :value="null">
                                {{ 'components.pages.registration.choose currency' | translate }}
                            </option>
                            <option v-for="(c, index) of visibleCurrencies" :key="index" :value="c.id">
                                {{ c.description }} ({{ c.id }})
                            </option>
                        </select>
                    </div>
                    <span class="icon is-left"><i class="fas fa-money-bill-alt"></i></span>
                    <p class="help is-danger" v-if="errors.has('currency:required')">
                        {{ 'components.pages.registration.validation.currency required' | translate }}
                    </p>
                </div>
            </div>
            <!-- Agreement input-->
            <div class="field bng-center-field">
                <div class="control">
                    <label class="checkbox">
                        <input
                            v-model="agreement"
                            data-vv-name="agreement"
                            data-vv-validate-on="change"
                            v-validate="'required'"
                            type="checkbox"
                        />
                        <span>{{ 'components.pages.registration.agreement' | translate }}</span>
                        <router-link target="_blank" :to="{ name: 'rules-inner', params: { rule: mainRulesRef && mainRulesRef.name } }">{{
                            'components.pages.registration.agreement rules' | translate
                        }}</router-link>
                    </label>
                    <p class="help is-danger" v-if="errors.has('agreement:required')">
                        {{ 'components.pages.registration.validation.agreement required' | translate }}
                    </p>
                </div>
            </div>

            <!-- Submit-->
            <button class="card-footer-item button is-large is-link" :class="{ 'is-loading': loading }" type="submit">
                <span>{{ 'components.pages.registration.continue' | translate }}</span>
                <span class="icon is-small"><i class="fas fa-arrow-right"></i></span>
            </button>
        </form>
    </div>
</template>

<script>
import Vue from 'vue';
import flatpickr from 'flatpickr';
import moment from 'moment-timezone';

import { mapGetters } from 'vuex';

import registrationService from '../../../../../../_common/services/registration.service';
import rulesHelper from '../../../../../../_common/helpers/rules.helper';
import currencyHelper from '../../../../../../_common/helpers/currency.helper';

import UniqueLoginValidationRule from '../../../../../../_common/mixins/unique-login.validation-rule.mixin';

import Recaptcha from '../../../common/recaptcha/recaptcha.vue';
import MaskedPhone from '../../../common/phone-number/phone-number-masked.vue';
//import RegistrationBonusBanner from "../banners/registration-bonus";

export default {
    name: 'registration-by-phone',
    $_veeValidate: { validator: 'new' },
    props: {
        toStep2: {
            type: Function,
            required: true
        },
        branchCode: {
            type: String
        }
    },
    components: { Recaptcha, MaskedPhone }, //, RegistrationBonusBanner
    mixins: [UniqueLoginValidationRule],
    data() {
        return {
            showPassword: false,
            phone: null,

            firstName: null,
            lastName: null,
            dateOfBirth: null,
            calendar: null,

            password: null,
            confirmedPassword: null,
            alias: null,
            messenger: null,
            error: null,
            recaptchaResponse: null,
            agreement: false,
            currency: null,
            loading: false,
            mainRulesRef: null,
            visibleCurrencies: null,
            messengerNames: {
                sms: 'SMS',
                wa: 'WhatsApp',
                tg: 'Telegram',
                vb: 'Viber'
            }
        };
    },
    computed: {
        ...mapGetters(['client']),
        askAliasDuringRegistration() {
            return this.client && this.client.view.auth.askAliasDuringRegistration;
        },
        registrationBonus() {
            let client = Vue.state.client.get();
            return client && client.bonus && client.bonus.registration;
        },
        registrationBanner() {
            return (
                this.client &&
                this.client.view.banners.registrationBanner &&
                this.registrationBonus &&
                this.registrationBonus.registrationTypes.indexOf('phone') >= 0
            );
        },
        availableMessengers() {
            return this.client && this.client.messengers.availableMessengers;
        },
        lang() {
            return Vue.state.lang.currentLang;
        },
        clientAlias() {
            return this.client && this.client.view && this.client.view.general && this.client.view.general.alias;
        },
        isLiveBetLine() {
            return this.clientAlias === 'LiveBetLine';
        }
    },
    async created() {
        this.messenger = this.availableMessengers[0];
        this.visibleCurrencies = await currencyHelper.getVisibleCurrencies();
        if (this.visibleCurrencies && this.visibleCurrencies.length) {
            this.currency = this.visibleCurrencies[0].id;
        }

        this.mainRulesRef = await rulesHelper.getMainRulesRef(this.lang);
    },
    mounted() {
        if (this.isLiveBetLine) {
            let calendarOptions = {
                enableTime: false,
                time_24hr: true,
                maxDate: moment()
                    .subtract(18, 'years')
                    .toDate(),
                disableMobile: 'true',
                onOpen: function(selectedDates, dateStr, instance) {
                    setTimeout(function() {
                        instance.open();
                    }, 200);
                }
            };

            this.calendar = flatpickr(this.$refs.dateOfBirth, calendarOptions);
        }
    },
    methods: {
        toggleShowPassword(ref) {
            this.loading = true;
            this.showPassword = !this.showPassword;
            setTimeout(() => this.$refs[ref].focus());
            this.loading = false;
        },
        async submit() {
            await this.$validator.validateAll();
            if (this.errors.any() || this.loading) return;

            this.errors.clear();
            this.loading = true;
            try {
                let model = {
                    phone: this.phone,
                    password: this.password,
                    alias: this.alias,
                    messenger: this.messenger,
                    language: Vue.state.lang.currentLang,
                    recaptchaResponse: this.recaptchaResponse,
                    currency: this.currency,
                    branchCode: this.branchCode
                };

                if (this.isLiveBetLine) {
                    model.firstName = this.firstName;
                    model.lastName = this.lastName;

                    let selectedDate = this.calendar.selectedDates[0];
                    model.dateOfBirth = moment(selectedDate).toISOString();
                }

                let response = await registrationService.registerByPhone(model);

                if (response.sent) {
                    this.toStep2({ phone: response.phone });
                } else {
                    this.error = this.$t('components.pages.registration.error ' + response.error.code);
                }
            } catch (ex) {
                console.log(ex);
                let response = ex.response && ex.response.data;
                this.error = this.$t('components.pages.registration.error general');
                if (response) {
                    console.error(`Failed to register new user: ${response}`);
                    if (response.code) {
                        this.error = this.$t('components.pages.registration.error code ' + response.code);
                    }
                }
            }
            this.loading = false;
        }
    }
};
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/registration/by-phone.vue